export default __webpack_public_path__ + "static/media/Animation - 1700800458439.14cf6dd5.gif";